export default __webpack_public_path__ + "static/media/about-us-1.8c90ddb7.jpg";